import { AiOutlineEye } from "react-icons/ai";
import { FaPrint } from "react-icons/fa";
import { FiShare } from "react-icons/fi";
import ThreeDots from "../../../../../assets/Images/threeDots.svg";
import { ThreeDotsActionProps } from "../interface";
import Image from "../../../../atoms/Image";
import { useNavigate } from "react-router";
import { MdOutlineDownloadDone } from "react-icons/md";

const ThreeDotsAction = ({ item, handlePrintSharePdf, handleReadyOrder }: ThreeDotsActionProps) => {
    const navigate = useNavigate();
    return (
        <div className="table-data-width">
            <button
                className="btn dropdown-dots shadow-none action-button"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <Image src={ThreeDots} />
            </button>
            <ul
                className="dropdown-menu dropdown-menu-end dropdown-style zindex-tooltip"
                aria-labelledby="dropdownMenuButton1"
                style={{ width: "210px" }}
            >
                {/* View Option */}
                {/* <li>
                    <button
                        className="dropdown-item dropdown-item-size"
                        onClick={() =>
                            navigate(`/sales-cart/${item.id}?e-delivered=${true}`)
                        }
                    >
                        <div className="d-flex align-items-center">
                            <AiOutlineEye />
                            <span className="ms-2 mb-0">View</span>
                        </div>
                    </button>
                </li>
                <hr className="my-1" /> */}

                {/* Print Option */}
                <li>
                    <button
                        className="dropdown-item dropdown-item-size"
                        onClick={() => handlePrintSharePdf(item?.id)}
                    >
                        <div className="d-flex align-items-center">
                            <FaPrint />
                            <span className="ms-2 mb-0">Order Form Pdf</span>
                        </div>
                    </button>
                </li>
                <hr className="my-1" />

                {/* Share Option */}
                <li>
                    <button className="dropdown-item dropdown-item-size"
                        onClick={() => handleReadyOrder(item?.id)}>
                        <div className='d-flex align-items-center'>
                            <MdOutlineDownloadDone size={'1.2em'} />
                            <span className='ms-2 mb-0'>To In Process Order</span>
                        </div>
                    </button>
                </li>
            </ul>
        </div>
    );
};

export default ThreeDotsAction;
